/** "1 persoon" / "0 personen" / "3 personen": the count followed by the right noun form. */
export const plural = (count: number, one: string, many: string): string => `${count} ${count === 1 ? one : many}`
